import React, { memo } from 'react'
import Seo from '../../../helpers/Seo/Seo'
import { C007Props } from './types'

/**
 * - C007 is a Rich text component used to display SEO copy.
 * - It offers the option to display the text in full or collapsed
 */

const C007 = ({ bodyCopy = '', collapsible = true }: C007Props): React.ReactElement =>
  bodyCopy && <Seo bodyCopy={bodyCopy} collapsible={collapsible} />

export default memo(C007)
